import{useEffect as t}from"react";function d(s,e){t(()=>{s&&document.documentElement.classList.add("group","is-native"),e&&document.documentElement.classList.add(`is-native-${e}`)},[s,e])}export{d as useAddNativeClasses};
//# sourceMappingURL=index.js.map
